
import { Router, Route, Switch } from 'wouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Header from './app/_components/common/Header';
import Footer from './app/_components/common/Footer';
// import ChatbotUI from './app/_components/chatbot/ChatbotUI';
import WhatsAppButton from './app/_components/common/WhatsAppButton';
import { Suspense, lazy } from 'react';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/home'));
const Servicios = lazy(() => import('./pages/servicios'));
const Servicio = lazy(() => import('./pages/servicio'));
const Cursos = lazy(() => import('./pages/cursos'));
const Curso = lazy(() => import('./pages/curso'));
const Blog = lazy(() => import('./pages/blog'));
const BlogPost = lazy(() => import('./pages/blog-post'));
const Contacto = lazy(() => import('./pages/contacto'));
const Nosotros = lazy(() => import('./pages/nosotros'));
const ParaEmpresas = lazy(() => import('./pages/para-empresas'));
const Recursos = lazy(() => import('./pages/recursos'));
const HerramientasIA = lazy(() => import('./pages/herramientas-ia'));
const TourIA = lazy(() => import('./pages/tour-ia'));
const Privacidad = lazy(() => import('./pages/privacidad'));
const Terminos = lazy(() => import('./pages/terminos'));
const Cookies = lazy(() => import('./pages/cookies'));
const Precios = lazy(() => import('./pages/precios'));
const NotFound = lazy(() => import('./pages/not-found'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          
          <main className="flex-grow">
            <Suspense fallback={
              <div className="flex items-center justify-center min-h-[50vh]">
                <div className="flex flex-col items-center space-y-4">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <p className="text-sm text-gray-600">Cargando página...</p>
                </div>
              </div>
            }>
              <Switch>
                <Route path="/" component={Home} />
                <Route path="/servicios" component={Servicios} />
                <Route path="/servicios/:slug" component={Servicio} />
                <Route path="/cursos" component={Cursos} />
                <Route path="/cursos/:slug" component={Curso} />
                <Route path="/blog" component={Blog} />
                <Route path="/blog/:slug" component={BlogPost} />
                <Route path="/contacto" component={Contacto} />
                <Route path="/nosotros" component={Nosotros} />
                <Route path="/para-empresas" component={ParaEmpresas} />
                <Route path="/recursos" component={Recursos} />
                <Route path="/herramientas-ia" component={HerramientasIA} />
                <Route path="/tour-ia" component={TourIA} />
                <Route path="/privacidad" component={Privacidad} />
                <Route path="/terminos" component={Terminos} />
                <Route path="/cookies" component={Cookies} />
                <Route path="/precios" component={Precios} />
                <Route component={NotFound} />
              </Switch>
            </Suspense>
          </main>
          
          <Footer />
          
          {/* Global components */}
          {/* <ChatbotUI /> */}
          <WhatsAppButton />
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
